<template>
  <VeeField
    v-if="useCartFormData().value.invoiceAddress != null"
    v-slot="{ field, meta, errors }"
    v-model="useCartFormData().value.invoiceAddress!.zip"
    name="zip"
    :rules="{ required: true, zip: true, zipDenyForCurrentBins: zipDenyForCurrentBins }"
  >
    <div :class="meta.touched ? (meta.valid ? 'valid' : 'invalid') : ''">
      <input v-bind="field" :class="inputClass" type="text" placeholder="PLZ*">
    </div>
    <span>{{ errors[0] }}</span>
  </VeeField>
</template>
<script setup lang="ts">
import { useCartFormData } from "~/composables/states";
type InputClass = string;

defineProps({
  zipDenyForCurrentBins: {
    type: Object,
    default: Array,
  },
  inputClass: {
    type: String as PropType<InputClass>,
    default: "inp sm",
  },
});
</script>
